import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

function AcceptanceChart(props) {
  let acceptanceDetails = props?.data || "";

  const getPercentValue = () => {
    let onboarded = acceptanceDetails?.onboarded || 0;
    let new_applicant = acceptanceDetails?.new_applicant || 0;
    if (!onboarded && !new_applicant) {
      return 0;
    }
    return Math.round((onboarded / new_applicant) * 100);
  };

  const percentage = getPercentValue();

  return (
    <div id="chart">
      <CircularProgressbar value={percentage} text={`${percentage}%`} />;
    </div>
  );
}
export default AcceptanceChart;
